module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title11"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429933391_tp01",
      "id": "toctitle9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429933391_p01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part One")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429933391_p02",
      "id": "toctitle2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part Two")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429933391_p03",
      "id": "toctitle3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part Three")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429933391_p04",
      "id": "toctitle4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part Four")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429933391_p05",
      "id": "toctitle5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part Five")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781429933391_fm01",
      "id": "toctitle6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AUTHOR’S NOTE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781429933391_fm02",
      "id": "toctitle7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Additional Praise for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The Empress of Weehawken")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_aboutAuthorPage",
    attrs: {
      "href": "#/e9781429933391_ata01",
      "id": "toctitle12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("About the Author")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429933391_bm01",
      "id": "toctitle8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Discussion Questions for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The Empress of Weehawken")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429933391_cop01",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d4a149c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429933391_toc01.vue
// module id = 60
// module chunks = 0